import { Button, Drawer, Flex, Result, theme } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactUs from "../Integrations/ContactUs";

const Feedback = ({
  shouldOpen,
  status,
}: {
  shouldOpen: boolean;
  status: "success" | "error";
}) => {
  const [open, setOpen] = useState(shouldOpen);
  const { i18n } = useTranslation();
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
    if (status === "success") {
      window.location.reload();
    }
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      width="43%"
      placement={i18n.language === "ar" ? "left" : "right"}
      closable={false}
    >
      <Result
        status={status}
        title={t(`templates.integrations.getpaid_activation.feedback.${status}.title`)}
        subTitle={t(`templates.integrations.getpaid_activation.feedback.${status}.description`)}
        style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}
        extra={
          <Flex gap={token.marginXS} vertical>
            <Button key="close" type="primary" size="large" onClick={handleClose}>
              {t("forms.buttons.done")}
            </Button>
            <ContactUs centered={true} />
          </Flex>
        }
      />
    </Drawer>
  );
};

export default Feedback;
